type Row = Record<string, string>;

function coerceRow(row: Record<string, unknown>): Row {
  const coerced: Row = {};
  for (const [k, v] of Object.entries(row)) {
    coerced[k] = v == null ? '' : String(v as string | number | boolean);
  }
  return coerced;
}

function parseColumnar(obj: Record<string, unknown>): Row[] {
  const columns = obj['columns'];
  const rows = obj['rows'];
  if (!Array.isArray(columns) || !Array.isArray(rows)) return [];
  const colNames = columns as string[];
  return (rows as unknown[][]).map((row) => {
    const out: Row = {};
    for (let i = 0; i < colNames.length; i++) {
      const v = row[i];
      out[colNames[i]!] = v == null ? '' : String(v as string | number | boolean);
    }
    return out;
  });
}

export function parseRows(content: string): Row[] {
  try {
    const parsed: unknown = JSON.parse(content);
    if (Array.isArray(parsed)) {
      return (parsed as Record<string, unknown>[]).map(coerceRow);
    }
    // Columnar format: {columns: string[], rows: unknown[][]}
    if (typeof parsed === 'object' && parsed !== null) {
      return parseColumnar(parsed as Record<string, unknown>);
    }
  } catch {
    // not valid JSON
  }
  return [];
}
